import { useTranslation } from 'react-i18next';

const YesNoAnswersData = () => {
  const { t } = useTranslation();

  return [{
    key: 'yes',
    text: t('tool_ui.global.radial_yes')
  }, {
    key: 'no',
    text: t('tool_ui.global.radial_no')
  }];
};

export default YesNoAnswersData;
